// extracted by mini-css-extract-plugin
export default {"doctor-commission-program-report-container":"DoctorCommissionProgramReport_doctor-commission-program-report-container__xgmhA"};